import {createStore} from "redux";

const initialState = {
    loginOpen: false,
    loginAfterExecute: null,
    liveOpen: false,
    liveMode: 'live',
    statusOpen: false,
    statusId : null,
    campaignIsNeedInitialize: false,
    user: {},
    isLogined: false,
    userProfileOpen: false,
    userProfileId:null,
    campaignUserLevel: 'NOT_LOGINED'
};

function reducer(state = initialState, action) {
    switch (action.type) {
        case 'LOGIN':
            return Object.assign({}, state, {
                loginOpen: true,
                loginAfterExecute: action.loginAfterExecute
            });
        case 'LOGIN_CLOSE':
            return Object.assign({}, state, {
                loginOpen: false
            });
        case 'LIVE_OPEN':
            return Object.assign({}, state, {
                liveOpen: true,
                liveMode: action.liveMode
            });
        case 'USER_PROFILE_OPEN':
            return Object.assign({}, state, {
                userProfileOpen: true,
                userProfileId:action.id
            });
        case 'USER_PROFILE_CLOSE':
            return Object.assign({}, state, {
                userProfileOpen: false,
                userProfileId:null
            });
        case 'STATUS_OPEN':
            return Object.assign({}, state, {
                statusOpen: true,
                statusId:action.statusId
            });
        case 'STATUS_CLOSE':
            return Object.assign({}, state, {
                statusOpen: false,
                statusId:null
            });
        case 'LIVE_CLOSE':
            return Object.assign({}, state, {
                liveOpen: false
            });
        case 'CAMPAIGN_USER_LEVEL':
            return Object.assign({}, state, {
                campaignUserLevel: action.campaignUserLevel
            });
        case 'CAMPAIGN_INITIALIZE':
            return Object.assign({}, state, {
                campaignIsNeedInitialize: true
            });
        case 'CAMPAIGN_INITIALIZE_OVER':
            return Object.assign({}, state, {
                campaignIsNeedInitialize: false
            });
        case 'OPEN_DISQUS':
            return Object.assign({}, state, {
                liveOpen: true,
                liveMode: 'disqus',
            });
        case 'RESOLVED_GET_USER':
            return Object.assign({}, state, {
                user: action.user
            });
        case 'IS_LOGINED':
            return Object.assign({}, state, {
                is_logined: action.is_logined
            })

        default:
            return state;
    }
}

const store = createStore(reducer);
export default store;


// WEBPACK FOOTER //
// ./src/lib/store.js